import { format } from 'date-fns';
import { FieldErrors } from 'react-hook-form/dist/types/errors';
import {
  ExpiresOn,
  MonthAvailability,
  TimeIntervalTypeValues,
} from 'src/components/oneCorp/features/MealCredit/common/formFields/mealCreditFormFields.utils';
import { BudgetResetTypeValues } from 'src/components/oneCorp/features/MealCredit/common/formFields/Select/BudgetResetTypeSelect/BudgetResetTypeSelect.utils';
import {
  IMealCreditFormFields,
  MealCreditLength,
} from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseManageMealCreditsPage.utils';

export interface MealCreditInfoTextProps {
  selectedDays: boolean[];
  budgetResetPeriod: number;
  isDailyLengthBudget: boolean;
  isWeeklyLengthBudget: boolean;
  isMonthlyLengthBudget: boolean;
  isMonthAvailable: boolean;
  budgetLength: MealCreditLength;
  budgetResetType: BudgetResetTypeValues;
  isRepeating: boolean;
  startDate: Date;
  endTimeFullDate: Date;
  expirationDate: Date;
  expiresOn: ExpiresOn;
  timeIntervalType: TimeIntervalTypeValues;
  refreshPeriodDaysCount?: number;
  refreshPeriodMonthsCount?: number;
  durationMinutes?: number;
  errors?: FieldErrors<IMealCreditFormFields>;
  monthAvailableOn?: MonthAvailability;
  monthAvailableTo?: Date;
}

export function getFormattedDate(date: Date): string {
  return format(date, 'M/d/yyyy');
}
